/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-danger */
import { ControlType, FieldType, type ControlProps } from '../../../../Form';
import { parseAddLabel } from '../../utils';
import type { CommonProps } from '../CommonProps';
import { CheckboxToggleCount } from '../getToggleField/Toggles';

type GetToggleField = {
  fieldName: string;
  labelText?: { __html: string };
  value: any;
  count?: number;
  commonProps: CommonProps;
  disabled?: boolean;
};

const getToggleWithoutContainerField = ({
  fieldName,
  labelText,
  value,
  count,
  commonProps,
  disabled,
}: GetToggleField): ControlProps => ({
  control: ControlType.CHECKBOX,
  name: fieldName,
  label: {
    text: (
      <>
        <div className="checkbox-toggle-html" dangerouslySetInnerHTML={labelText} />
        {count ? (
          <CheckboxToggleCount countOnTheLeft={!commonProps.isMobile && !commonProps.isSidebar}>
            {parseAddLabel({ withBrackets: !commonProps.isMobile && !commonProps.isSidebar, count })}
          </CheckboxToggleCount>
        ) : null}
      </>
    ),
  },
  value,
  default: false,
  type: FieldType.TOGGLE,
  disabled: commonProps.isWaiting || disabled,
});

export default getToggleWithoutContainerField;
